/* block-tabbed-collection.js — behaviour for the "Tabbed Collections" theme block
   (blocks/ai_gen_block_d6639e3.liquid): tab switching with keyboard support, the
   per-tab product carousels with prev/next arrows, and the SHOP ALL link that follows
   the active tab. Defines the <tabbed-collection> element once; the block loads this
   file (deferred) after snippets/notice-touch-axis.liquid, which supplies
   window.noticeBindTouchAxis for the mouse-drag axis lock. */
(function () {
  if (window.customElements.get('tabbed-collection')) return;

  class TabbedCollection extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.ai-tab');
      this.contents = this.querySelectorAll('.ai-tab-content');
      this.prevButtons = this.querySelectorAll('.ai-carousel-arrow-prev');
      this.nextButtons = this.querySelectorAll('.ai-carousel-arrow-next');
      this.carousels = this.querySelectorAll('.ai-products-carousel');
      this.viewAllButton = this.querySelector('[data-view-all]');
      this.productSpacing = parseInt(this.getAttribute('data-product-spacing'), 10) || 0;
      this.activeTabIndex = 0;
    }

    connectedCallback() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.activeTabIndex = index;
          this.setActiveTab(tab.getAttribute('data-tab'));
          this.updateViewAllLink();
        });
        tab.addEventListener('keydown', (e) => {
          var last = this.tabs.length - 1;
          var target = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') target = index === last ? 0 : index + 1;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') target = index === 0 ? last : index - 1;
          else if (e.key === 'Home') target = 0;
          else if (e.key === 'End') target = last;
          if (target === null) return;
          e.preventDefault();
          var nextTab = this.tabs[target];
          this.activeTabIndex = target;
          this.setActiveTab(nextTab.getAttribute('data-tab'));
          this.updateViewAllLink();
          nextTab.focus();
        });
      });
      this.updateViewAllLink();
      this.prevButtons.forEach((btn, i) => {
        btn.addEventListener('click', () => { if (this.carousels[i]) this.scrollCarousel(this.carousels[i], -1); });
      });
      this.nextButtons.forEach((btn, i) => {
        btn.addEventListener('click', () => { if (this.carousels[i]) this.scrollCarousel(this.carousels[i], 1); });
      });
      var _resizeTimer;
      this.carousels.forEach((carousel, i) => {
        var prev = this.prevButtons[i];
        var next = this.nextButtons[i];
        if (!prev || !next) return;
        this.bindTouchAxis(carousel);
        this.updateArrowVisibility(carousel, prev, next);
        carousel.addEventListener('scroll', () => { this.updateArrowVisibility(carousel, prev, next); }, { passive: true });
        window.addEventListener('resize', () => {
          clearTimeout(_resizeTimer);
          _resizeTimer = setTimeout(() => { this.updateArrowVisibility(carousel, prev, next); }, 150);
        }, { passive: true });
      });
    }

    updateViewAllLink() {
      if (!this.viewAllButton) return;
      var activeTab = this.tabs[this.activeTabIndex];
      if (!activeTab) return;
      var url = activeTab.getAttribute('data-collection-url');
      if (url) this.viewAllButton.href = url;
    }

    setActiveTab(tabId) {
      this.tabs.forEach((tab) => {
        var active = tab.getAttribute('data-tab') === tabId;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      this.contents.forEach((content) => {
        content.classList.toggle('active', content.getAttribute('data-tab-content') === tabId);
      });
      // Re-evaluate arrows after tab switch (carousel resets to start)
      var idx = parseInt(tabId, 10) - 1;
      var carousel = this.carousels[idx];
      var prev = this.prevButtons[idx];
      var next = this.nextButtons[idx];
      if (carousel && prev && next) {
        setTimeout(() => { this.updateArrowVisibility(carousel, prev, next); }, 50);
      }
    }

    scrollCarousel(carousel, direction) {
      var card = carousel.querySelector('.ai-product-card');
      if (!card) return;
      carousel.scrollBy({ left: direction * (card.offsetWidth + this.productSpacing), behavior: 'smooth' });
    }

    bindTouchAxis(carousel) {
      if (!window.noticeBindTouchAxis) return;
      window.noticeBindTouchAxis(carousel, {
        suppressClick: true,
        shouldIgnore: function (e) { return e.pointerType !== 'mouse'; },
        onPanX: function () { carousel._noticeSuppressClick = true; }
      });
    }

    updateArrowVisibility(carousel, prev, next) {
      var atStart = carousel.scrollLeft <= 1;
      var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 1;
      prev.style.display = atStart ? 'none' : 'block';
      next.style.display = atEnd ? 'none' : 'block';
    }
  }

  window.customElements.define('tabbed-collection', TabbedCollection);
})();
